<div class="w-full max-w-7xl items-center">
  <section class="mt- mb-8 flex lg:mb-0" aria-label="Forgot password">
    <div
      class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:p-10"
    >
      <!-- Comcast Business Logo -->
      <div class="mb-8 flex md:justify-center">
        <a
          routerLink="/"
          class="inline-block"
          aria-label="Comcast Business — go to homepage"
        >
          <img
            src="assets/images/logos/CB_Logo_Color_RGB.svg"
            alt=""
            role="presentation"
            class="h-10 w-auto md:h-14"
          />
        </a>
      </div>

      <!-- Title -->
      <h2
        id="forgot-password-heading"
        class="font-montserrat mt-4 text-lg font-bold text-black lg:text-2xl"
      >
        Forgot your Password?
      </h2>

      @if (displayForm()) {
        <div class="font-lato my-4 flex text-base">
          Enter the username registered with Nitel and a link will be sent to
          you to reset your password.
        </div>

        <form
          [formGroup]="forgotPasswordFormGroup"
          novalidate
          aria-labelledby="forgot-password-heading"
          (ngSubmit)="submitForgotPasswordForm()"
        >
          <label for="username" class="comcast-input-label">Username</label>
          <input
            formControlName="username"
            id="username"
            type="text"
            required
            name="username"
            autocomplete="username"
            aria-describedby="username-error"
            [attr.aria-invalid]="errorMessage()?.length ? 'true' : 'false'"
            [ngClass]="{
              'comcast-input-invalid': errorMessage()?.length > 0,
            }"
            class="comcast-input"
            placeholder="Enter your username"
          />
          <div aria-live="polite">
            @if (errorMessage()?.length) {
              <span id="username-error" class="comcast-validation-error">
                {{ errorMessage() }}
              </span>
            }
          </div>

          <div class="mt-6 flex">
            <button
              type="submit"
              [disabled]="isLoading()"
              [attr.aria-busy]="isLoading()"
              class="btn-primary"
            >
              @if (isLoading()) {
                <span class="sr-only">Sending, please wait</span>
                <div class="flex min-w-16 justify-center" aria-hidden="true">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              } @else {
                <mat-icon
                  class="mr-2 flex h-4.5! w-4.5! align-middle! text-lg! leading-none!"
                  aria-hidden="true"
                  >mail</mat-icon
                >
                SEND
              }
            </button>
          </div>

          <div
            class="font-lato mt-4 flex justify-center text-sm lg:justify-start"
          >
            Need Help? Call us at&nbsp;
            <a href="tel:8884502100" aria-label="Call us at 888-450-2100"
              >888-450-2100</a
            >
          </div>
        </form>
      } @else {
        <div
          class="font-lato mt-4 flex text-base"
          role="status"
          aria-live="polite"
        >
          If an account exists for that username, you'll receive an email with
          instructions to reset your password.
        </div>
        <div class="mt-6 flex justify-center">
          <a routerLink="/login" aria-label="Back to login" class="btn-primary">
            Back to Login
          </a>
        </div>
      }
    </div>
  </section>
</div>
